export default __webpack_public_path__ + "static/media/OCGO-slider5.e86b1a4c.jpg";